import ScreenResolution from './ScreenResolution.vue';

export default {
  'x-debug-screen-resolution': ScreenResolution,
}
